import { render } from "./RevokeLicenseModal.vue?vue&type=template&id=385a46a6&scoped=true"
import script from "./RevokeLicenseModal.vue?vue&type=script&lang=js"
export * from "./RevokeLicenseModal.vue?vue&type=script&lang=js"

import "./RevokeLicenseModal.vue?vue&type=style&index=0&id=385a46a6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-385a46a6"]])

export default __exports__